import { c as _c } from "react/compiler-runtime";
import { Badge, CopyButton, Dialog } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { FormattedRegistration } from '../../../../onboarding-business-insight.types';
import { statusVariant } from '../../constants';
import useRegistrationStatusText from '../../hooks/use-registration-status-text';
import LineItem from '../line-item';
const Section = t0 => {
  const $ = _c(5);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <p className="text-label-2 text-primary pb-1">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <div className="flex flex-col gap-3">{t1}{children}</div>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export type RegistrationDetailsProps = {
  registration: FormattedRegistration;
  onClose: () => void;
};
const RegistrationDetails = t0 => {
  const $ = _c(93);
  const {
    registration: t1,
    onClose
  } = t0;
  const {
    state,
    status,
    jurisdiction,
    subStatus,
    name,
    entityType,
    addresses,
    registeredAgent,
    registrationDate,
    fileNumber,
    source
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "onboardings.registrations"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t2);
  const statusT = useRegistrationStatusText();
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== state) {
    t4 = <p className="text-label-2 text-primary">{state}</p>;
    $[3] = state;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== status || $[6] !== statusT) {
    t5 = status && <Badge variant={statusVariant[status]}>{statusT(status)}</Badge>;
    $[5] = status;
    $[6] = statusT;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <header className="flex justify-between py-2 px-4 bg-secondary border-b border-solid border-tertiary rounded-t">{t4}{t5}</header>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t(_temp2);
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t(_temp3);
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== jurisdiction || $[16] !== t8) {
    t9 = <LineItem label={t8} value={jurisdiction} />;
    $[15] = jurisdiction;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t(_temp4);
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== subStatus || $[21] !== t10) {
    t11 = <LineItem label={t10} value={subStatus} />;
    $[20] = subStatus;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t7 || $[25] !== t9) {
    t12 = <Section title={t7}>{t9}{t11}</Section>;
    $[23] = t11;
    $[24] = t7;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t(_temp5);
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t(_temp6);
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== name || $[32] !== t14) {
    t15 = <LineItem label={t14} value={name} />;
    $[31] = name;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t(_temp7);
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== entityType || $[37] !== t16) {
    t17 = <LineItem label={t16} value={entityType} />;
    $[36] = entityType;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t13 || $[40] !== t15 || $[41] !== t17) {
    t18 = <Section title={t13}>{t15}{t17}</Section>;
    $[39] = t13;
    $[40] = t15;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t) {
    t19 = t(_temp8);
    $[43] = t;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== addresses) {
    t20 = addresses.map(_temp9);
    $[45] = addresses;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t19 || $[48] !== t20) {
    t21 = <Section title={t19}>{t20}</Section>;
    $[47] = t19;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t) {
    t22 = t(_temp10);
    $[50] = t;
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t) {
    t23 = t(_temp11);
    $[52] = t;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== registeredAgent || $[55] !== t23) {
    t24 = <LineItem label={t23} value={registeredAgent} />;
    $[54] = registeredAgent;
    $[55] = t23;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== t22 || $[58] !== t24) {
    t25 = <Section title={t22}>{t24}</Section>;
    $[57] = t22;
    $[58] = t24;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== t) {
    t26 = t(_temp12);
    $[60] = t;
    $[61] = t26;
  } else {
    t26 = $[61];
  }
  let t27;
  if ($[62] !== t) {
    t27 = t(_temp13);
    $[62] = t;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== registrationDate || $[65] !== t27) {
    t28 = <LineItem label={t27} value={registrationDate} />;
    $[64] = registrationDate;
    $[65] = t27;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== t) {
    t29 = t(_temp14);
    $[67] = t;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] !== fileNumber || $[70] !== t29) {
    t30 = <LineItem label={t29} value={fileNumber} />;
    $[69] = fileNumber;
    $[70] = t29;
    $[71] = t30;
  } else {
    t30 = $[71];
  }
  let t31;
  if ($[72] !== source || $[73] !== t) {
    t31 = source ? <LineItem label={t(_temp15)} customValue={<div className="flex min-w-0 max-w-[60%] items-center justify-end gap-1"><p className="text-body-2 text-primary truncate">{source}</p><CopyButton ariaLabel={t(_temp16)} contentToCopy={source} tooltip={{
        position: "left"
      }} size="compact" /></div>} /> : <LineItem label={t(_temp17)} value={source} />;
    $[72] = source;
    $[73] = t;
    $[74] = t31;
  } else {
    t31 = $[74];
  }
  let t32;
  if ($[75] !== t26 || $[76] !== t28 || $[77] !== t30 || $[78] !== t31) {
    t32 = <Section title={t26}>{t28}{t30}{t31}</Section>;
    $[75] = t26;
    $[76] = t28;
    $[77] = t30;
    $[78] = t31;
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  let t33;
  if ($[80] !== t12 || $[81] !== t18 || $[82] !== t21 || $[83] !== t25 || $[84] !== t32) {
    t33 = <div className="flex flex-col gap-8 py-4 px-6">{t12}{t18}{t21}{t25}{t32}</div>;
    $[80] = t12;
    $[81] = t18;
    $[82] = t21;
    $[83] = t25;
    $[84] = t32;
    $[85] = t33;
  } else {
    t33 = $[85];
  }
  let t34;
  if ($[86] !== t33 || $[87] !== t6) {
    t34 = <div className="flex flex-col justify-between rounded border border-solid border-tertiary">{t6}{t33}</div>;
    $[86] = t33;
    $[87] = t6;
    $[88] = t34;
  } else {
    t34 = $[88];
  }
  let t35;
  if ($[89] !== onClose || $[90] !== t3 || $[91] !== t34) {
    t35 = <Dialog onClose={onClose} open={true} title={t3}>{t34}</Dialog>;
    $[89] = onClose;
    $[90] = t3;
    $[91] = t34;
    $[92] = t35;
  } else {
    t35 = $[92];
  }
  return t35;
};
export default RegistrationDetails;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.dialog.statusDetails.title;
}
function _temp3($_1) {
  return $_1.dialog.statusDetails.jurisdiction;
}
function _temp4($_2) {
  return $_2.dialog.statusDetails.subStatus;
}
function _temp5($_3) {
  return $_3.dialog.entityDetails.title;
}
function _temp6($_4) {
  return $_4.dialog.entityDetails.name;
}
function _temp7($_5) {
  return $_5.dialog.entityDetails.entityType;
}
function _temp8($_6) {
  return $_6.dialog.addresses.title;
}
function _temp9(address) {
  return <p key={address} className="text-body-2 text-primary">{address}</p>;
}
function _temp10($_7) {
  return $_7.dialog.people.title;
}
function _temp11($_8) {
  return $_8.dialog.people.agent;
}
function _temp12($_9) {
  return $_9.dialog.filingDetails.title;
}
function _temp13($_10) {
  return $_10.dialog.filingDetails.date;
}
function _temp14($_11) {
  return $_11.dialog.filingDetails.fileNumber;
}
function _temp15($_12) {
  return $_12.dialog.filingDetails.source;
}
function _temp16($_13) {
  return $_13.dialog.filingDetails.sourceAriaLabel;
}
function _temp17($_14) {
  return $_14.dialog.filingDetails.source;
}